import type { CalendarPlatform } from 'src/meetings/models';
import { CalendarAccountIcon } from './CalendarAccountIcon';
import { ActionRow } from 'src/meetings/components/ActionRow';

type Props = {
  platform: CalendarPlatform;
  title: string;
  subtitle?: string;
  connectText: string;
  onConnect?: () => void;
  onDisconnect?: () => void;
  disabled?: boolean;
};

export const CalendarAccountCard = ({
  platform,
  title,
  subtitle,
  connectText,
  onConnect,
  disabled,
}: Props) => {
  return (
    <ActionRow
      title={title}
      subtitle={subtitle}
      icon={<CalendarAccountIcon platform={platform} />}
      button={{
        label: connectText,
        onClick: onConnect,
        variant: 'primary',
        disabled: disabled,
      }}
    />
  );
};
